//	Dataviewから配列への変換
export const dataviewToArray = (argData: any) => {
  let retVal = new Array(argData.byteLength)
  for (let i = 0; i < argData.byteLength; ++i) {
    retVal[i] = argData.getUint8(i)
  }
  return retVal
}
